import { ReactNode } from "react"
import AnalyticsContext, { useAnalyticsWithProperties } from "connected-components/analytics/context"
import { DeepReadonly } from "ts-essentials"
import { useAiTeammateContext } from "../hooks/context"
import { useExtractAiTeammateContextProperties } from "./extract-context-properties"

interface AiTeammateAnalyticsProviderProps {
  children: ReactNode
}

/**
 * Provides AI Teammate analytics context with automatic property extraction
 * and "AI Teammate" prefix for all events.
 *
 * This provider wraps children with analytics context that includes:
 * - AI Teammate context
 * - "AI Teammate" prefix for all tracked events
 *
 * Should be used within an AiTeammateProvider.
 */
export function AiTeammateAnalyticsProvider({
  children,
}: DeepReadonly<AiTeammateAnalyticsProviderProps>) {
  const aiTeammateContext = useAiTeammateContext()

  const contextProperties = useExtractAiTeammateContextProperties(aiTeammateContext)

  const analyticsContextValue = useAnalyticsWithProperties(contextProperties, "AI Teammate")

  return (
    <AnalyticsContext.Provider value={analyticsContextValue}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export default AiTeammateAnalyticsProvider
